import { useContextState } from "../../../../../../../hooks/theme"

const useStyles = () => {
  const { colors } = useContextState()

  return {
    padding: {
      padding: '10px',
    },
    containerTooltip: {
      width: '350px',
      borderRadius: '5px',
      overflow: 'hidden',
      height: 'fit-content',
      zIndex: 10000,
      background: colors.color5,
      position: 'absolute',
      top: '-30px',
      left: '30px'
    },
    userPoint: {
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '10px',
      zIndex: 1,
    },
    location: {
      color: colors.color2,
      fontSize: '40px',
      '& .MuiSvgIcon-root': {
        fontSize: '1em',
      },
    },
    flex: {
      display: 'flex',
      flexDirection: 'column',
      gap: 1
    },
    relative: {
      position: 'relative'
    },
  }
}

export { useStyles }